<template>
  <div class="container-fluid">
    <div class="loader_fs" v-if="loading">
      <Loader />
    </div>
    <div class="row">
      <div class="col-md-12">
        <transition :name="animations.fadeIn.name" :enter-active-class="animations.fadeIn.enter" :leave-active-class="animations.fadeIn.leave">
          <div class="card" v-if="!loading && items">
                <div class="card-header">
            <h5>Dienstleister</h5>
            </div>
            <div class="card-body">
              <b-row>
                <b-col md="12" class="list_mode">
                  <b-input-group class="datatable-btn">
                    <div class="input-group">
                      <b-form-input style="border:1px solid lightgrey" v-model="filter" placeholder="Suchen"></b-form-input>
                    </div>
                  </b-input-group>
                </b-col>
              </b-row>
              <div class="table-responsive datatable-vue" v-if="items">
                <b-table
                  :select-mode="selectMode"
                  show-empty
                  stacked="md"
                  :items="items"
                  :fields="tablefields"
                  :filter="filter"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @filtered="onFiltered"
                  @row-selected="rowSelected"
                >
                  <template v-slot:cell(aktionen)="row">
                    <div class="input-group iam-buttons">
                      <feather
                        :id="'edit-dl-' + row.item.id"
                        type="edit-2"
                        class="infra-blue icon-margin-right pointer"
                        @click="$router.push('dienstleister/' + row.item.id)"
                      ></feather>
                      <b-tooltip :target="'edit-dl-' + row.item.id" triggers="hover" placement="left">Dienstleister bearbeiten</b-tooltip>                   
                      
                    </div>
                  </template>
                  <template slot="empty">
                    <div class="text-center">Keine Dienstleister gefunden.</div>
                  </template>
                </b-table>
              </div>
              <div class="flex-row-sb col-12">
                <b-col md="6" class="my-1" v-if="totalRows > perPage">
                  <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                </b-col>
                           <div class="flex-row-end" style="margin-top:30px;">
         <b-button class="btn btn-primary" @click="openModal('newDienstleister')">Neuer Dienstleister</b-button>
       </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <b-modal size="md" id="newDienstleister" name="name" @ok.prevent="validate" @cancel="closeModal">
      <div class="card-body">
        <label>Name</label>
        <b-input-group prepend="Abc">
          <b-form-input class="form-control" v-model="name" v-bind:class="{ form_error: hasError('name') }"></b-form-input>
          <feather type="x" v-if="hasError('name') && !updating.name" class="failmark"></feather>
          <Loader size="20" v-if="updating.name" class="loader" style="position:absolute!important;top:10px;right:15px;" />
        </b-input-group>
      </div>
      <template slot="modal-ok">
        Erstellen
      </template>
      <template slot="modal-cancel">
        Abbrechen
      </template>
      <template slot="modal-title">
        Neuer Dienstleister
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader.vue";

export default {
  name: "AdminDienstleister",
  components: {
    Loader: Loader,
  },
  data() {
    return {
      tablefields: [
        { key: "name", label: "Name", sortable: true },
        { key: "extended.branchenString", label: "Branchen", sortable: true },
        { key: "email", label: "email", sortable: true },
        { key: "telefon", label: "phone", sortable: true },
        { key: "aktionen", label: "aktionen", sortable: false },
      ],
      validation_errors: [],
      name: "",
      updating: {
        name: false,
      },
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 50, 100],
      selectMode: "single",
      selected: [],
      items: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      dienstleister: "app/dienstleister",
      ready: "app/readyState",
      toast: "app/toasts",
      animations: "app/animations",
    }),
  },
  async mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  async created() {
    try {
      this.loading = true;
      await this.$store.dispatch("app/apiGetDienstleister");

      this.loading = false;
    } catch (error) {
      console.log(error);
    }
    this.items = this.dienstleister;
    this.totalRows = this.items.length;
  },
  methods: {
    async validate() {
      const fieldName = "name";
      const errorExists = this.validation_errors.indexOf(fieldName);
      if (errorExists > -1) this.validation_errors.splice(errorExists, 1);
      this.updating[fieldName] = true;

      const validationPayload = {
        context: "dienstleister",
        field: fieldName,
        value: this["name"],
      };

      const validation_result = await this.$store.dispatch("app/validateField", validationPayload);
      if (!validation_result) {
        this.validation_errors.push(fieldName);
        this.updating[fieldName] = false;
        return;
      }

      //create the new Dienstleister

      try {
        this.updating.name = true;
        const response = await this.$directus.createItem("dienstleister", { name: this.name, status: "published" });
        await this.$store.dispatch("app/apiGetDienstleister");
        this.updating.name = false;
        this.$router.push("/admin/dashboard/dienstleister/" + response.data.id);
      } catch (error) {
        this.$toasted.show("Fehler beim Erstellen des Dienstleisters.", this.toast.failure);
        this.updating.name = false;
      }
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    openModal(modal) {
      this.$bvModal.show(modal);
    },
    closeModal(modalRef) {
      this.$bvModal.hide(modalRef.componentId);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    rowSelected(item) {
      this.selected = item;
    },
    handleSelect(selection) {
      let isSelected = this.selected.indexOf(selection.item);
      if (isSelected > -1) {
        this.selected.splice(isSelected, 1);
      } else {
        this.selected.push(selection.item);
      }
    },
  },
};
</script>

<style scoped>
.loader {
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  -moz-backdrop-filter: none;
}
.loader,
.checkmark,
.failmark {
  position: absolute;
  bottom: 0px;
  right: 10px;
  display: block;
  height: 20px;
  width: 20px;
}

.checkmark.select,
.loader.select {
  right: 30px;
  z-index: 1000;
}
</style>
<style></style>
